/**
 * @file: Contractor.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 承包商信息
 */
import request from '@/utils/request'

/**
 * 获取承包商列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constractorListGet(data) {
  return request({
    type: 'biz',
    url: 'constractor/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取输入ID，对应的学校ID（wzp）
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constractorOrgId(data) {
  return request({
    type: 'biz',
    url: 'constractor/org/id',
    method: 'post',
    data
  })
}

/**
 * 档口情况(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constractorStallDetail(data) {
  return request({
    type: 'biz',
    url: 'constractor/stall/detail',
    method: 'post',
    data
  })
}

/**
 * 商家档案(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constractorStallList(data) {
  return request({
    type: 'biz',
    url: 'constractor/stall/list',
    method: 'post',
    data
  })
}

/**
 * 获取所属组织，主体或者非主体都适用，数据查询访问：1、本组织所属的组织和子组织列表 2、组织及子组织所承包的食堂（页面：体温明细列表-所属组织）(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageAllorgListGet(data) {
  return request({
    type: 'biz',
    url: 'constramanage/allorg/list/get',
    method: 'post',
    data
  })
}

/**
 * 根据食堂ID，获取承包商列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageContraListGet(data) {
  return request({
    type: 'biz',
    url: 'constramanage/contra/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取食堂-承包商-人员关系列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageDcuListGet(data) {
  return request({
    type: 'biz',
    url: 'constramanage/dcu/list/get',
    method: 'post',
    data
  })
}

/**
 * 删除食堂-承包商管理(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageDelete(data) {
  return request({
    type: 'biz',
    url: 'constramanage/delete',
    method: 'post',
    data
  })
}

/**
 * 根据承包商ID、学校ID，获取食堂列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageDeptListGet(data) {
  return request({
    type: 'biz',
    url: 'constramanage/dept/list/get',
    method: 'post',
    data
  })
}

/**
 * 关键字获取食堂列表(app监管)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageDeptOrgListGet(data) {
  return request({
    type: 'biz',
    url: 'constramanage/dept/org/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取 食堂-点位（组织）-承包商 信息列表（食堂人员管理列表）(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageDeptorgcontraAllmainListGet(data) {
  return request({
    type: 'biz',
    url: 'constramanage/deptorgcontra/allmain/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取 食堂-点位（组织）-承包商 信息列表(非主体)(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageDeptorgcontraNomainListGet(data) {
  return request({
    type: 'biz',
    url: 'constramanage/deptorgcontra/nomain/list/get',
    method: 'post',
    data
  })
}

/**
 * 根据食堂ID，获取承包商列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageDoContraListGet(data) {
  return request({
    type: 'biz',
    url: 'constramanage/do/contra/list/get',
    method: 'post',
    data
  })
}

/**
 * 根据主键ID获取食堂-承包商管理(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageGet(data) {
  return request({
    type: 'biz',
    url: 'constramanage/get',
    method: 'post',
    data
  })
}

/**
 * 新增食堂-承包商管理(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageInsert(data) {
  return request({
    type: 'biz',
    url: 'constramanage/insert',
    method: 'post',
    data
  })
}

/**
 * 获取食堂-承包商管理列表(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageListGet(data) {
  return request({
    type: 'biz',
    url: 'constramanage/list/get',
    method: 'post',
    data
  })
}

/**
 * 承包商登录，获取体系-承包商-学校-食堂信息(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageLoginListGet(data) {
  return request({
    type: 'biz',
    url: 'constramanage/login/list/get',
    method: 'post',
    data
  })
}

/**
 * 承包商关联页面，获取组织（学校、主体）列表（页面：添加食堂公示-所属组织）(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageMainBycontractorListGet(data) {
  return request({
    type: 'biz',
    url: 'constramanage/main/bycontractor/list/get',
    method: 'post',
    data
  })
}

/**
 * 管理方登录，获取体系-组织信息(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageManagerloginListGet(data) {
  return request({
    type: 'biz',
    url: 'constramanage/managerlogin/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取组织-学校-运营商(包括组织下食堂以及承包的食堂)(wrp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageOrgDeptConstractorListGet(data) {
  return request({
    type: 'biz',
    url: 'constramanage/org/dept/constractor/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取学校食堂列表(cme)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageOrgDeptListGet(data) {
  return request({
    type: 'biz',
    url: 'constramanage/org/dept/list/get',
    method: 'post',
    data
  })
}

/**
 * 获取承包商关联的学校列表
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageOrgListGet(data) {
  return request({
    type: 'biz',
    url: 'constramanage/org/list/get',
    method: 'post',
    data
  })
}

/**
 * 更新食堂-承包商管理(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function constramanageUpdate(data) {
  return request({
    type: 'biz',
    url: 'constramanage/update',
    method: 'post',
    data
  })
}

/**
 * 获取学校食堂列表(包含一店一码)(cme)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function wechatConstramanageOrgDeptListGet(data) {
  return request({
    type: 'biz',
    url: 'wechat/constramanage/org/dept/list/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Contractor.js